/** Mirror of the daemon's page size, required by the web build root and checked by webMirrorContracts. */
export const CHAT_HISTORY_PAGE_SIZE = 50;
